<template>
  <v-container
    id="outstanding"
    class="pa-0"
  >
    <v-progress-linear
      v-show="loading"
      indeterminate
      color="red darken-4"
    />
    <div
      v-if="!loading"
    >
      <v-row>
        <v-col
          cols="12"
          md="3"
        >
          <v-select
            v-model="editedItem.payrollCalendar"
            :items="outstandingOptions"
            :error-messages="formErrors.PayrollCalendar"
            :disabled="disabled"
            label="Payroll Calendar"
          />
        </v-col>
        <v-col
          cols="12"
          md="9"
        >
          <v-text-field
            v-model="editedItem.payrollCalendarNotes"
            :error-messages="formErrors.PayrollCalendarNotes"
            :disabled="disabled"
            label="Payroll Calendar Notes"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="3"
        >
          <v-select
            v-model="editedItem.finalCompletedEECensus"
            :items="outstandingOptions"
            :error-messages="formErrors.FinalCompletedEECensus"
            :disabled="disabled"
            label="Final Completed EE Census"
          />
        </v-col>
        <v-col
          cols="12"
          md="9"
        >
          <v-text-field
            v-model="editedItem.finalCompletedEECensusNotes"
            :error-messages="formErrors.FinalCompletedEECensusNotes"
            :disabled="disabled"
            label="Final Completed EE Census Notes"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="3"
        >
          <v-select
            v-model="editedItem.inForceCarrierCoverage"
            :items="outstandingOptions"
            :error-messages="formErrors.InForceCarrierCoverage"
            :disabled="disabled"
            label="In Force Carrier Coverage"
          />
        </v-col>
        <v-col
          cols="12"
          md="9"
        >
          <v-text-field
            v-model="editedItem.inForceCarrierCoverageNotes"
            :error-messages="formErrors.InForceCarrierCoverageNotes"
            :disabled="disabled"
            label="In Force Carrier Coverage Notes"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="3"
        >
          <v-select
            v-model="editedItem.payrollCodes"
            :items="outstandingOptions"
            :error-messages="formErrors.PayrollCodes"
            :disabled="disabled"
            label="Payroll Codes"
          />
        </v-col>
        <v-col
          cols="12"
          md="9"
        >
          <v-text-field
            v-model="editedItem.payrollCodesNotes"
            :error-messages="formErrors.PayrollCodes"
            :disabled="disabled"
            label="Payroll Code Notes"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="3"
        >
          <v-select
            v-model="editedItem.healthRatesFinalized"
            :items="outstandingOptions"
            :error-messages="formErrors.HealthRatesFinalized"
            :disabled="disabled"
            label="Health Rates Finalized"
          />
        </v-col>
        <v-col
          cols="12"
          md="9"
        >
          <v-text-field
            v-model="editedItem.healthRatesFinalizedNotes"
            :error-messages="formErrors.HealthRatesFinalizedNotes"
            :disabled="disabled"
            label="Health Rates Finalized Notes"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="3"
        >
          <v-select
            v-model="editedItem.dentalRatesFinalized"
            :items="outstandingOptions"
            :error-messages="formErrors.DentalRatesFinalized"
            :disabled="disabled"
            label="Dental Rates Finalized"
          />
        </v-col>
        <v-col
          cols="12"
          md="9"
        >
          <v-text-field
            v-model="editedItem.dentalRatesFinalizedNotes"
            :error-messages="formErrors.DentalRatesFinalizedNotes"
            :disabled="disabled"
            label="Dental Rates Finalized Notes"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="3"
        >
          <v-select
            v-model="editedItem.visionRatesFinalized"
            :items="outstandingOptions"
            :error-messages="formErrors.VisionRatesFinalized"
            :disabled="disabled"
            label="Vision Rates Finalized"
          />
        </v-col>
        <v-col
          cols="12"
          md="9"
        >
          <v-text-field
            v-model="editedItem.visionRatesFinalizedNotes"
            :error-messages="formErrors.VisionRatesFinalizedNotes"
            :disabled="disabled"
            label="Vision Rates Finalized Notes"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="3"
        >
          <v-select
            v-model="editedItem.cobraRatesFinalized"
            :items="outstandingOptions"
            :error-messages="formErrors.CobraRatesFinalized"
            :disabled="disabled"
            label="Cobra Rates Finalized"
          />
        </v-col>
        <v-col
          cols="12"
          md="9"
        >
          <v-text-field
            v-model="editedItem.cobraRatesFinalizedNotes"
            :error-messages="formErrors.CobraRatesFinalizedNotes"
            :disabled="disabled"
            label="Cobra Rates Finalized Notes"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="3"
        >
          <v-select
            v-model="editedItem.finalCarrierDocumentsSubmitted"
            :items="outstandingOptions"
            :error-messages="formErrors.FinalCarrierDocumentsSubmitted"
            :disabled="disabled"
            label="Final Carrier Documents Submitted"
          />
        </v-col>
        <v-col
          cols="12"
          md="9"
        >
          <v-text-field
            v-model="editedItem.finalCarrierDocumentsSubmittedNotes"
            :error-messages="formErrors.FinalCarrierDocumentsSubmittedNotes"
            :disabled="disabled"
            label="Final Carrier Documents Submitted Notes"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="3"
        >
          <v-select
            v-model="editedItem.carriersNotifiedTesting"
            :items="outstandingOptions"
            :error-messages="formErrors.CarriersNotifiedTesting"
            :disabled="disabled"
            label="Carriers Notified Testing"
          />
        </v-col>
        <v-col
          cols="12"
          md="9"
        >
          <v-text-field
            v-model="editedItem.carriersNotifiedTestingNotes"
            :error-messages="formErrors.CarriersNotifiedTestingNotes"
            :disabled="disabled"
            label="Carriers Notified Testing Notes"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="3"
        >
          <v-select
            v-model="editedItem.troodonTesting"
            :items="outstandingOptions"
            :error-messages="formErrors.TroodonTesting"
            :disabled="disabled"
            label="Booklet Review"
          />
        </v-col>
        <v-col
          cols="12"
          md="9"
        >
          <v-text-field
            v-model="editedItem.troodonTestingNotes"
            :error-messages="formErrors.TroodonTestingNotes"
            :disabled="disabled"
            label="Booklet Review Notes"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="3"
        >
          <v-select
            v-model="editedItem.billingFormSubmitted"
            :items="outstandingOptions"
            :error-messages="formErrors.BillingFormSubmitted"
            :disabled="disabled"
            label="Billing Form Submitted"
          />
        </v-col>
        <v-col
          cols="12"
          md="9"
        >
          <v-text-field
            v-model="editedItem.billingFormSubmittedNotes"
            :error-messages="formErrors.BillingFormSubmittedNotes"
            :disabled="disabled"
            label="Billing Form Submitted Notes"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="3"
        >
          <v-select
            v-model="editedItem.other"
            :items="outstandingOptions"
            :error-messages="formErrors.Other"
            :disabled="disabled"
            label="Payroll/Upload File Invite Sent"
          />
        </v-col>
        <v-col
          cols="12"
          md="9"
        >
          <v-text-field
            v-model="editedItem.otherNotes"
            :error-messages="formErrors.OtherNotes"
            :disabled="disabled"
            label="Payroll/Upload File Invite Sent Notes"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
        >
          <v-text-field
            v-model="editedItem.notes"
            :error-messages="formErrors.Notes"
            :disabled="disabled"
            :light="light"
            label="Notes"
          />
        </v-col>
      </v-row>
      <div>
        <v-btn
          v-show="!disabled"
          color="green darken-1"
          text
          @click="save()"
        >
          Save
        </v-btn>
      </div>
      <v-progress-linear
        v-show="savingData"
        indeterminate
        color="red darken-4"
      />
    </div>
    <base-material-snackbar
      v-model="displayError"
      type="error"
      v-bind="{
        top: true,
        right: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
    <base-material-snackbar
      v-model="displaySuccess"
      type="success"
      v-bind="{
        top: true,
        right: true
      }"
    >
      {{ successMessage }}
    </base-material-snackbar>
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'
  import { extractFormErrors, getErrorTitle } from '@/services/ErrorHandlers'

  export default {
    name: 'Outstanding',

    props: {
      openEnrollment: {
        type: Object,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      editedItem: {},
      loading: true,
      savingData: false,
      formErrors: {},

      light: false,

      errorMessage: null,
      displayError: false,

      successMessage: null,
      displaySuccess: false,

      outstandingOptions: ['Outstanding', 'Completed', 'N/A'],

      oeOutstandingResource: new TroodyApi('oeOutstanding/'),
    }),

    computed: {
      safeFormErrors () {
        return this.formErrors || {}
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.formErrors = {}
        this.fetchOutstanding()
      },

      showError (error, msg) {
        console.log(error)
        this.errorMessage = (error || msg)
        this.displayError = true
      },

      fetchOutstanding () {
        this.loading = true
        this.oeOutstandingResource.query({ openEnrollmentId: this.openEnrollment.id })
          .then(data => {
            this.loading = false
            this.editedItem = (data && data.length) ? data[0] : {}
            console.log(this.editedItem)
          })
          .catch((error) => {
            this.loading = false
            this.editedItem = null
            this.showError(error, 'Failed to load deduction details!')
          })
      },

      save () {
        this.savingData = true
        const payload = Object.assign(this.editedItem, {})
        payload.openEnrollmentId = this.openEnrollment.id
        this.oeOutstandingResource.save(payload)
          .then((data) => {
            this.savingData = false
            this.editedItem = data
            this.successMessage = 'Saved successfully!'
            this.displaySuccess = true
          })
          .catch((error) => {
            this.savingData = false
            this.formErrors = extractFormErrors(error)
            if (this.formErrors) {
              this.showError(getErrorTitle(error), 'Failed to save!')
            } else {
              this.formErrors = {}
              this.showError(error, 'Failed to save!')
            }
          })
      },
    },
  }
</script>
